import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Ingredients from './ingredients'
import Information from './information'
import Nerdy from './nerdy'

function RandomBeer() {
    const [name, setName] = useState();
    const [volumeValue, setVolumeValue] = useState();
    const [volumeUnit, setVolumeUnit] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [tagLine, setTagLine] = useState();
    const [description, setDescription] = useState();
    const [hops, setHops] = useState([]);
    const [malts, setMalts] = useState([]);
    const [yeast, setYeast] = useState();
    const [firstBrewed, setFirstBrewed] = useState();
    const [boilVolume, setBoilVolume] = useState([]);
    const [fermentationTemp, setFermentationTemp] = useState([]);
    const [twist, setTwist] = useState();
    const [mashTemp, setMashTemp] = useState([]);
    const [mashDuration, setMashDuration] = useState();
    const [food, setFood] = useState([]);


    const fetchRequest = useCallback(() => {
        fetch("https://api.punkapi.com/v2/beers/random").
            then(results => results.json())
            .then(data => {
                setName(data[0].name);
                const { volume } = data[0];
                const { ingredients } = data[0];
                const { method } = data[0];
                setVolumeValue(volume.value);
                setVolumeUnit(volume.unit);
                setImageUrl(data[0].image_url);
                setTagLine(data[0].tagline);
                setDescription(data[0].description);
                setHops(ingredients.hops);
                setMalts(ingredients.malt);
                setYeast(ingredients.yeast);
                setFirstBrewed(data[0].first_brewed);
                setBoilVolume(data[0].boil_volume);
                setFermentationTemp(method.fermentation.temp);
                setTwist(method.twist);
                setMashTemp(method.mash_temp[0].temp);
                setMashDuration(method.mash_temp[0].duration);
                setFood(data[0].food_pairing);
            })
            scrollToTop(0);
    }, []);
    function scrollToTop(){
        window.scrollTo({
            top:0,
            behavior:"smooth"
        })
    }

    return (
        <>
            {name !== undefined ?
                <section>
                    <Information
                        name={name}
                        volumeValue={volumeValue}
                        volumeUnit={volumeUnit}
                        imageUrl={imageUrl}
                        tagLine={tagLine}
                        description={description}
                        firstBrewed={firstBrewed}
                        food={food}
                    />

                    <Ingredients
                        hops={hops}
                        malts={malts}
                        yeast={yeast}
                    />
                    <Nerdy 
                    boilVolume={boilVolume}
                    mashTemp={mashTemp}
                    mashDuration={mashDuration}
                    twist={twist}
                    fermentationTemp={fermentationTemp}
                    />
                </section>
                :
                <h2 className="text-center p-3">Find a beer</h2>
            }
            <div className="d-flex justify-content-center py-3">
                <button onClick={fetchRequest} className="btn btn-outline-success">{name == undefined ? "Beer Me!" : "More Beer!"}</button>
            </div>

        </>
    )

}


export default RandomBeer